import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles<Theme>(theme => ({
  root: {
    display: 'grid',
    height: '100svh',
    gridTemplateColumns: '100%',
    gridTemplateRows: 'auto 1fr auto'
  },

  modalTitle: {
    marginBottom: '0px',
    fontSize: theme.size.lg,
    color: '#1F1F1F'
  },

  modalClose: {
    top: '16px',
    right: '12px',

    [theme.breakpoints.down('sm')]: {
      top: '6px'
    }
  },

  dataRoot: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #C6C6C6',
    borderRadius: '4px',
    boxSizing: 'border-box',
    marginTop: 16,
    transition: 'all 250ms',

    [theme.breakpoints.down('lg')]: {
      flex: 1
    }
  },

  editorRoot: {
    overflow: 'hidden auto',

    '& .toolbar': {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      padding: ' 0px 0px 4px 0px',
      backgroundColor: 'white'
    },

    '& .editor-input': {
      minHeight: 'calc(100svh - 305px)',

      [theme.breakpoints.down('sm')]: {
        minHeight: '150px'
      }
    }
  },

  titleInput: {
    outline: 0,
    border: 'none',
    height: 30,
    fontSize: theme.size.base,
    textOverflow: 'ellipsis',
    padding: '5px 10px',

    '&::placeholder': {
      color: '#888888 !important'
    }
  },

  sectionRoot: {
    display: 'flex',
    position: 'relative',
    boxSizing: 'border-box',
    marginTop: '16px',
    alignItems: 'center',
    borderBottom: '1px solid #C6C6C6',
    paddingBottom: '8px'
  },

  btnSection: {
    justifyContent: 'space-between',
    display: 'flex',
    margin: '16px 0px'
  },

  btnOptions: {
    display: 'flex',
    gap: 4
  },

  tertiaryBtn: {
    width: 'auto'
  },

  btnClass: {
    width: 'auto'
  },

  pinBtnClass: {
    marginLeft: '0 !important',

    '& > button': {
      width: 'auto !important'
    },

    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}))

export default useStyles
